import { render, staticRenderFns } from "./TeamDashboard.vue?vue&type=template&id=2ab7fd6e&scoped=true&"
import script from "./TeamDashboard.vue?vue&type=script&lang=js&"
export * from "./TeamDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TeamDashboard.vue?vue&type=style&index=0&id=2ab7fd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab7fd6e",
  null
  
)

export default component.exports